import { PermissionName } from '@sironamedical/common/constants/permissionName';
import { useValidateUserHasRbacPermissions } from 'hooks/useValidateUserHasRbacPermissions';

/**
 * Reporter "Bypass and Sign" is enabled only when the user has
 * PermissionName.AllowBypassSignCountdown
 *
 * Note: used to require both REPORTER_BYPASS_SIGNING ff and this permission (RP-5152).
 * The flag was removed (RP-5154), so access is via RBAC.
 */
export const useBypassSignEnabled = (): boolean => {
  return useValidateUserHasRbacPermissions({
    permissionNames: [PermissionName.AllowBypassSignCountdown],
  });
};
